export const timeOfTheWorkingDay = "05:00";

export const TAX_FEE = 0.1;
export const TAX_LABEL = '10%';

export const TicketStatusKey = {
  PENDING: "pending",
  CLOSED: "closed",
  INVESTIGATING: "investigating",
  AWAITING_RESPONSE: "awaiting_response",
  OTHER: "other",
};

export const TicketStatusValue = {
  PENDING: "در انتظار پاسخ اپراتور",
  CLOSED: "بسته شده",
  INVESTIGATING: "در حال پیگیری",
  AWAITING_RESPONSE: "در انتظار پاسخ کاربر",
  OTHER: "نامشخص",
};

export const OrderStatusValue = {
  ALL: "همه",
  APPROVED: "تایید شده",
  SUCCESSFUL: "پرداخت شده",
  PENDING: "در انتظار تایید",
  DENIED: "رد شده",
  CANCELED: "لغو شده",
  PAYMENT_REQUIRED: "در انتظار پرداخت",
  UNSUCCESSFUL: "ناموفق",
};

export const DepartmentKey = {
  TECHNICAL: 'technical',
  FINANCIAL: 'financial',
  SUPERVISION: 'supervision',
  OTHER: "other",
};

export const DepartmentValue = {
  TECHNICAL: 'پشتیبانی فنی',
  FINANCIAL: 'امور مالی و حسابداری',
  SUPERVISION: 'واحد نظارت و اطلاع رسانی',
  OTHER: "نامشخص",
};
